import React, { useState, useRef, useEffect } from 'react';
import API_REST from '../../../api-rest-uruk';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import ScreenWithGrids from './ScreenWithGrids';
import LoadingCard from '../../UI/LoadingCard';

import API from '../../../api-graphql';

const CreateBundle = (props) => {
  const { match, config, subgroup } = props;

  const documentId = match.params.number;

  const formRef = useRef(null);
  const history = useHistory();

  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const getListTemplates = async () => {
      let loadComplete = false;
      let nextToken;
      while (!loadComplete) {
        try {
          const filter = {
            status: { ne: 'deleted' },
            subgroups: { contains: subgroup }
          };
          let result = await API.listTemplates(filter, nextToken);
          setTemplates(s => [...s, ...result.data.listTemplates.items]);
          nextToken = result.data.listTemplates.nextToken;
          if (!result.data.listTemplates.nextToken) {
            loadComplete = true;
          }
        } catch (error) {
          console.error('Error occurred while fetching document', error);
        } finally {
          setLoading(false);
        }
      }
    };

    getListTemplates();
  }, []);

  const onSubmit = async (formData) => {
    setLoading(true);
    const body = {
      configId: config.id,
      ...formData,
      subgroups: [subgroup],
      files
    };
    API_REST.createBundle(body)
      .then(() => {
        history.push('/bundle');
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  return (
    <>
      <LoadingCard open={loading} loading message='Creando bundle' />
      <ScreenWithGrids
        config={config}
        onSubmit={onSubmit}
        documentId={documentId}
        loading={loading}
        formRef={formRef}
        setFiles={setFiles}
        templates={templates}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    config: state.config,
    subgroup: state.config.subgroup
  };
};

export default connect(mapStateToProps, null)(CreateBundle);
